import { render, staticRenderFns } from "./SplitBadge.vue?vue&type=template&id=2814382a&lang=pug"
import script from "./SplitBadge.vue?vue&type=script&lang=js"
export * from "./SplitBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports